(function () {

    'use strict';

    angular.module('FotocApp')

        .component('bound', {

            templateUrl: window.BASE_PATH + '/backend/backend/bound.component.html',
            bindings: {
                pos: '<',
                editorData: '<',
                details: '<',
                sin: '@'
            },


            controller: ['$scope', '$editorService', '$canvasService', '$timeout', '$http', '$lang', function ($scope, $editorService, $canvasService, $timeout, $http, $lang) {

                var self = this;
                self.metric = 'cm';

                this.BASE_PATH = window.BASE_PATH;
                this.DIFF_STAPLE = 2;

                function getPositionForManual($layoutObj, $EDITOR_DATA) {
                    var ret;
                    try {
                        ret = $layoutObj.sizes[$EDITOR_DATA.layout_size].arrange[self.pos];
                    } catch (e) {
                        ret = self.pos;
                        try {
                            ret = $layoutObj.arrange[self.pos];
                        } catch (e) {
                            ret = self.pos + 1;
                        }
                    }
                    return ret;
                }

                this.$onInit = function () {
                    var EDITOR_DATA = self.editorData;

                    //("POS: " + this.pos)
                    //console.log(EDITOR_DATA);

                    var image;
                    if (EDITOR_DATA.group === 1) {
                        image = EDITOR_DATA.images[0];
                    } else {
                        image = EDITOR_DATA.images[self.pos];
                    }

                    var template = CONFIG_DATA[EDITOR_DATA.type].data.layouts[EDITOR_DATA.layout_id.toString()].sizes[EDITOR_DATA.layout_size];
                    self.template = template;
                    self.BASE_PATH = window.BASE_PATH;
                    self.bleeding = CONFIG_DATA[EDITOR_DATA.type].config.config.bleeding;
                    self.frame_weight = CONFIG_DATA[EDITOR_DATA.type].config.config.frame_weight;
                    self.staples = CONFIG_DATA[EDITOR_DATA.type].config.config.staples;
                    self.size = template.sizes[self.pos];

                    self.cant_3m = CONFIG_DATA[EDITOR_DATA.type].config.config['3m'][(self.size[0] + 'x' + self.size[1])] ? CONFIG_DATA[EDITOR_DATA.type].config.config['3m'][self.size[0] + 'x' + self.size[1]] : 1;
                    self.cant_cross_frame = CONFIG_DATA[EDITOR_DATA.type].config.config['cross_frame'][(self.size[0] + 'x' + self.size[1])] ? CONFIG_DATA[EDITOR_DATA.type].config.config['cross_frame'][self.size[0] + 'x' + self.size[1]] : 0;

                    self.positionRefManual = getPositionForManual(CONFIG_DATA[EDITOR_DATA.type].data.layouts[EDITOR_DATA.layout_id.toString()], EDITOR_DATA);
                    self.hash_composition = String("C" + EDITOR_DATA.material + EDITOR_DATA.layout_id.toString() + EDITOR_DATA.layout_size + String(self.positionRefManual)).toUpperCase();

                    if (typeof (self.sin) === 'undefined') {
                        self.sin = Math.random();
                    }

                    JsBarcode("#barcode", self.sin, {
                        width: .4,
                        height: 25,
                        fontSize: 8,
                        margin: 5
                    });


                    if (typeof (image.urlFinalImage) !== "undefined" && image.urlFinalImage.length > 0) {
                        self.image_url = image.urlFinalImage;
                    } else if (image.urlWithFilter.length > 0) {
                        self.image_url = image.urlWithFilter;
                    } else {
                        self.image_url = image.urlWithoutFilter;
                    }

                    self.frameColor = 'transparent';
                    if (image.frameColor != 'NONE') {
                        self.frameColor = image.frameColor;
                    }

                    var b;
                    if (EDITOR_DATA.group === 1) {
                        b = template.size_group;
                    } else {
                        b = self.size;
                    }

                    var multip;
                    var ex;
                    if (template.size_group[0] > template.size_group[1]) {
                        multip = template.size_group[0] / 1000;
                        ex = 0;
                    } else {
                        multip = template.size_group[1] / 1000;
                        ex = getMinorLeftBound(template.bounds) * multip;
                    }


                    self.x = template.bounds[self.pos][0] * multip;
                    self.y = template.bounds[self.pos][1] * multip;

                    var _x = image.position.x * multip;
                    var _y = image.position.y * multip;

                    self.center = (self.size[0] / 2) + self.bleeding + self.frame_weight;
                    self.centerMark = ((template.size_group[0] / 2) - (self.x) + (ex) + self.bleeding + self.frame_weight);

                    var _scale = image.position.scaleX
                    var _rotate = image.position.rotation

                    self.image_pos = {
                        scale: _scale,
                        rotate: _rotate,
                        x: _x,
                        y: _y
                    };

                    if (image.type === "my_galery") {
                        adjuntImageInBound(image.data.originalImageInfo.width, image.data.originalImageInfo.height, b)
                    } else {
                        adjuntImageInBound(image.data.assets.large_thumb.width, image.data.assets.large_thumb.height, b)
                    }
                }

                this.slice = function ($str, $start, $end) {
                    return String($str).slice($start, $end)
                }

                function getMinorLeftBound(bounds) {
                    var minor = 9999;
                    bounds.forEach(function (b) {

                        if (b[0] < minor) {
                            minor = b[0];
                        }

                    });
                    return minor;
                }

                function adjuntImageInBound($src_w, $src_h, bounds) {
                    var ratio = 1;
                    var resize_w;
                    var resize_h;

                    if (($src_w / $src_h) > (bounds[0] / bounds[1])) {
                        resize_h = bounds[1] + (self.bleeding * 2);
                        resize_w = $src_w * resize_h / $src_h;
                        ratio = resize_h / $src_h;
                    } else {
                        resize_w = bounds[0] + (self.bleeding * 2)
                        resize_h = $src_h * resize_w / $src_w;
                        ratio = resize_w / $src_w;
                    }

                    self.image_dim = {
                        w: resize_w,
                        h: resize_h,
                        scale: ratio
                    }
                }
            }]
        })
})();